import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 662.000000 479.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,479.000000) scale(0.100000,-0.100000)">
<path d="M1130 3558 c0 -81 -7 -77 181 -80 l168 -3 -140 -245 c-78 -135 -157
-274 -176 -310 -20 -36 -42 -74 -50 -85 -31 -45 -32 -45 312 -45 198 0 325 4
325 9 0 21 -72 131 -85 131 -8 0 -71 -5 -140 -11 -70 -6 -129 -8 -132 -6 -3 3
14 37 36 75 23 39 41 72 41 75 0 2 23 46 51 98 133 245 219 409 219 419 0 7
-99 10 -305 10 l-305 0 0 -32z"/>
<path d="M4410 3494 c-41 -7 -76 -13 -77 -13 -2 -1 -3 -37 -3 -81 l0 -80 -34
0 c-37 0 -45 -12 -38 -62 4 -24 9 -28 37 -28 l33 0 4 -172 c4 -188 10 -214 61
-252 23 -17 43 -21 100 -21 40 1 89 7 110 14 35 12 37 15 37 53 l0 41 -38 -7
c-26 -4 -45 -1 -60 10 -21 14 -22 22 -22 175 l0 159 55 0 55 0 0 45 0 45 -55
0 -55 0 0 95 c0 108 11 101 -110 79z"/>
<path d="M4855 3334 c-16 -3 -58 -14 -93 -25 -49 -16 -62 -25 -58 -37 2 -10 7
-32 11 -49 4 -18 9 -33 11 -33 3 0 23 9 45 21 22 11 62 23 88 26 40 4 51 2 74
-18 18 -16 28 -36 29 -59 3 -33 1 -35 -37 -43 -167 -35 -212 -56 -245 -109
-27 -44 -27 -120 0 -163 34 -55 132 -81 197 -53 15 7 42 23 59 35 39 29 40 29
48 -7 l6 -30 95 0 c100 0 111 6 78 43 -15 16 -19 47 -23 206 -3 102 -9 193
-14 201 -20 33 -53 62 -84 76 -37 15 -139 25 -187 18z m113 -355 c3 -51 0 -59
-24 -78 -44 -35 -85 -27 -103 21 -18 49 3 93 53 107 61 19 71 12 74 -50z"/>
<path d="M2571 3319 c-13 -5 -36 -18 -51 -29 -37 -27 -50 -25 -50 5 l0 26 -77
-7 c-43 -4 -79 -7 -80 -8 -1 -1 -3 -116 -4 -256 l-2 -255 87 -3 86 -3 0 205 0
205 40 12 c33 10 43 9 65 -5 l25 -16 0 -200 0 -200 85 0 86 0 -1 202 -2 202
27 13 c37 20 84 8 96 -24 5 -13 9 -107 9 -209 l0 -184 100 0 c55 0 100 3 100
7 0 3 -8 15 -17 26 -15 16 -19 47 -23 211 -4 168 -7 195 -25 226 -46 78 -152
91 -241 30 l-46 -33 -22 26 c-11 14 -31 30 -43 36 -26 13 -89 13 -122 0z"/>
<path d="M3960 3319 c-13 -6 -39 -21 -57 -35 l-33 -25 0 32 0 31 -82 -7 c-46
-4 -86 -9 -90 -12 -5 -2 -8 -119 -8 -259 l0 -254 95 0 95 0 0 205 0 205 26 10
c39 15 79 12 97 -8 15 -16 17 -46 17 -215 l0 -197 110 0 c61 0 110 3 110 7 0
3 -8 15 -17 26 -15 16 -19 47 -23 211 -6 217 -15 250 -76 279 -38 19 -124 22
-164 6z"/>
<path d="M1830 3306 l-75 -11 -3 -193 c-2 -173 0 -198 17 -237 44 -100 165
-114 269 -29 l32 27 0 -24 c0 -46 10 -50 114 -47 l98 3 -21 27 c-20 25 -21 38
-21 262 0 200 -2 236 -15 236 -8 0 -48 -5 -90 -11 l-75 -11 0 -184 0 -183 -30
-16 c-41 -21 -76 -19 -94 7 -13 18 -16 56 -16 210 0 104 -3 187 -7 187 -5 -1
-42 -7 -83 -13z"/>
<path d="M3212 3307 l-73 -10 3 -206 c3 -222 8 -246 59 -283 57 -43 160 -30
221 27 15 14 29 25 32 25 3 0 6 -15 8 -32 l3 -33 98 -3 c101 -3 113 3 83 37
-11 12 -15 71 -19 250 -3 128 -8 236 -11 238 -3 3 -41 0 -86 -7 l-80 -12 0
-178 0 -179 -26 -20 c-15 -12 -38 -21 -53 -21 -55 0 -56 4 -61 216 -3 120 -9
198 -15 199 -5 1 -43 -3 -83 -8z"/>
<path d="M1887 2663 c-4 -3 -7 -44 -7 -90 l0 -83 59 0 c48 0 63 4 85 25 30 28
35 78 11 112 -22 31 -128 57 -148 36z m111 -45 c7 -7 12 -26 12 -43 0 -40 -16
-55 -57 -55 l-33 0 0 55 0 55 33 0 c18 0 38 -5 45 -12z"/>
<path d="M2315 2661 c-9 -16 3 -31 26 -31 17 0 19 -7 19 -70 0 -63 2 -70 20
-70 18 0 20 7 20 70 0 69 1 70 26 70 19 0 25 4 22 18 -3 13 -16 18 -65 20 -36
2 -64 -1 -68 -7z"/>
<path d="M2550 2637 c-11 -17 -20 -35 -20 -40 0 -4 -11 -30 -24 -57 -23 -47
-23 -50 -5 -50 10 0 23 9 29 20 8 15 21 20 50 20 29 0 42 -5 50 -20 10 -19 46
-30 38 -12 -29 72 -76 163 -86 167 -7 2 -21 -10 -32 -28z m42 -42 c0 -8 1 -20
2 -27 1 -6 -7 -12 -16 -14 -13 -1 -18 5 -18 20 0 34 28 53 32 21z"/>
<path d="M2852 2654 c-12 -8 -22 -26 -22 -40 0 -19 10 -29 47 -47 26 -12 46
-26 45 -32 -2 -5 -23 -9 -47 -8 -31 1 -45 -3 -45 -12 0 -16 22 -25 61 -25 46
0 69 17 69 49 0 28 -17 42 -68 56 -39 11 -23 40 21 38 42 -3 53 20 15 31 -36
9 -52 7 -76 -10z"/>
<path d="M3037 2664 c-4 -4 -7 -45 -7 -91 l0 -83 65 0 c51 0 65 3 65 15 0 11
-12 15 -50 15 -43 0 -50 3 -50 19 0 16 8 20 42 23 59 4 63 28 4 28 -39 0 -46
3 -46 19 0 17 8 20 48 23 34 2 47 7 47 18 0 11 -14 16 -55 18 -31 2 -59 0 -63
-4z"/>
<path d="M3243 2663 c-9 -3 -13 -31 -13 -89 0 -68 3 -84 15 -84 9 0 15 9 15
24 0 45 37 45 60 0 7 -13 22 -24 32 -24 22 0 23 13 3 30 -8 7 -15 18 -15 25 0
7 7 15 15 19 23 9 20 73 -5 86 -22 12 -88 20 -107 13z m93 -48 c9 -23 -16 -46
-45 -43 -20 2 -27 9 -29 31 -3 25 -1 27 33 27 23 0 38 -6 41 -15z"/>
<path d="M3427 2663 c-8 -15 72 -173 88 -173 17 0 88 147 81 167 -9 24 -31 3
-51 -49 -11 -28 -25 -53 -30 -55 -6 -2 -17 14 -24 34 -23 66 -51 99 -64 76z"/>
<path d="M3824 2661 c-86 -37 -61 -170 33 -171 41 0 63 9 63 27 0 10 -8 12
-34 8 -19 -4 -43 -2 -54 4 -63 33 -13 126 54 101 30 -12 48 -2 35 18 -10 17
-70 24 -97 13z"/>
<path d="M3997 2664 c-4 -4 -7 -45 -7 -91 l0 -83 65 0 c51 0 65 3 65 15 0 11
-12 15 -45 15 -38 0 -45 3 -45 19 0 16 8 20 37 23 52 4 56 28 4 28 -34 0 -41
3 -41 20 0 17 7 20 46 20 37 0 45 3 42 17 -2 13 -16 18 -58 21 -31 2 -59 0
-63 -4z"/>
<path d="M4213 2658 c-48 -23 -38 -62 23 -89 27 -11 44 -25 44 -35 0 -14 -8
-16 -46 -11 -38 4 -45 2 -42 -12 5 -24 84 -28 109 -5 10 9 19 25 19 35 0 20
-36 49 -61 49 -9 0 -22 7 -30 16 -17 21 5 36 43 28 32 -6 46 11 19 25 -24 13
-49 13 -78 -1z"/>
<path d="M2137 2578 c-23 -54 -32 -84 -24 -87 6 -2 17 6 25 18 20 29 91 30 99
1 3 -11 14 -20 25 -20 23 0 21 10 -23 107 -40 89 -57 86 -102 -19z m67 16 c11
-29 6 -43 -14 -41 -11 1 -20 7 -20 13 0 19 11 44 20 44 4 0 11 -7 14 -16z"/>
<path d="M3665 2637 c-3 -12 -4 -49 -2 -82 4 -45 9 -61 21 -63 14 -3 16 9 16
82 0 69 -3 86 -15 86 -8 0 -17 -10 -20 -23z"/>
<path d="M1240 2580 l-95 -6 80 -2 c44 -1 171 -5 283 -9 184 -6 202 -5 202 10
0 15 -19 17 -187 15 -104 -1 -231 -5 -283 -8z"/>
<path d="M4470 2577 c0 -15 19 -17 188 -16 103 1 252 5 332 9 l145 6 -121 2
c-66 1 -216 5 -332 9 -193 6 -212 5 -212 -10z"/>
<path d="M4430 2373 c-92 -15 -195 -62 -252 -115 -59 -56 -66 -88 -70 -289 -3
-183 -3 -184 24 -239 20 -41 41 -64 79 -90 51 -35 53 -35 183 -40 72 -3 201
-2 286 2 145 7 159 10 217 38 209 103 231 411 42 591 -98 93 -250 150 -399
148 -47 -1 -96 -4 -110 -6z m205 -53 c22 -9 24 -12 13 -30 -10 -16 -24 -20
-61 -20 -80 0 -137 -50 -137 -120 0 -35 38 -96 94 -149 35 -34 36 -34 52 -15
40 50 94 139 94 155 0 10 12 32 26 49 33 38 44 27 44 -45 0 -61 -27 -120 -104
-232 -51 -73 -61 -83 -88 -83 -32 0 -32 -3 -12 65 4 16 -2 23 -29 33 -99 36
-168 171 -137 269 31 97 153 158 245 123z m66 -65 c-1 -15 -24 -12 -29 3 -3 9
2 13 12 10 10 -1 17 -7 17 -13z m-76 -40 c51 -50 18 -125 -54 -125 -47 0 -71
24 -71 71 0 70 77 103 125 54z m-25 -455 c0 -13 5 -17 19 -13 10 2 26 -3 35
-12 37 -38 -6 -96 -54 -72 -20 10 -26 21 -28 56 -2 24 -1 50 2 58 8 19 26 7
26 -17z m104 9 c-3 -5 -10 -7 -15 -3 -5 3 -7 10 -3 15 3 5 10 7 15 3 5 -3 7
-10 3 -15z m46 -44 c0 -37 -4 -65 -10 -65 -6 0 -10 28 -10 65 0 37 4 65 10 65
6 0 10 -28 10 -65z m-206 9 c19 -18 21 -45 4 -62 -17 -17 -67 -15 -74 3 -9 24
4 63 24 68 29 8 30 8 46 -9z m166 -29 c0 -19 -4 -37 -10 -40 -6 -4 -10 12 -10
40 0 28 4 44 10 40 6 -3 10 -21 10 -40z m139 26 c12 -22 5 -31 -26 -31 -12 0
-23 -4 -23 -10 0 -5 12 -10 26 -10 14 0 23 -4 19 -10 -9 -14 -48 -13 -63 2 -7
7 -12 21 -12 33 0 43 60 63 79 26z m-401 -33 c4 -43 -15 -53 -20 -11 -4 38
-28 42 -28 4 0 -43 -17 -47 -24 -6 -9 44 -24 45 -28 3 -4 -48 -22 -40 -26 10
l-3 43 63 -3 63 -3 3 -37z"/>
<path d="M4613 1723 c-21 -8 -15 -43 6 -43 11 0 23 5 27 11 8 14 -17 38 -33
32z"/>
<path d="M4493 1704 c-8 -22 18 -37 36 -20 7 8 10 19 7 25 -10 16 -36 13 -43
-5z"/>
<path d="M4795 1720 c-3 -5 3 -10 14 -10 12 0 21 5 21 10 0 6 -6 10 -14 10 -8
0 -18 -4 -21 -10z"/>
<path d="M2505 2321 c-157 -6 -173 -8 -209 -30 -73 -46 -76 -58 -76 -307 0
-122 3 -236 7 -254 10 -50 72 -107 125 -115 24 -3 176 -7 340 -8 l296 -2 27
25 c52 48 55 64 48 351 -6 287 -10 307 -63 334 -31 16 -143 17 -495 6z m247
-74 c42 -32 23 -120 -37 -177 -33 -31 -43 -19 -15 19 25 36 23 74 -3 79 -35 7
-66 -8 -123 -60 l-57 -53 5 47 c6 54 42 109 92 139 36 22 112 25 138 6z m-112
-144 c0 -5 -7 -17 -15 -27 -33 -44 -10 -72 44 -56 41 11 40 -5 0 -19 -100 -35
-155 15 -90 80 27 27 61 39 61 22z m-106 -159 c25 -10 19 -34 -9 -34 -24 0
-34 18 -18 33 8 8 8 8 27 1z m371 -6 c2 -7 5 -50 8 -95 3 -74 2 -83 -14 -83
-9 0 -20 7 -23 16 -8 21 -8 159 1 167 10 11 23 8 28 -5z m-192 -50 c9 -5 9
-10 -1 -20 -14 -14 -16 -78 -2 -78 6 0 10 -7 10 -15 0 -18 -31 -20 -48 -3 -7
7 -12 41 -12 84 0 61 3 73 18 76 11 2 18 -4 21 -17 1 -11 8 -23 14 -27z m115
-4 c42 -29 24 -74 -29 -74 -10 0 -19 -4 -19 -10 0 -5 14 -10 30 -10 20 0 30
-5 30 -15 0 -10 -10 -15 -33 -15 -43 0 -65 17 -73 57 -5 26 -1 37 19 57 30 30
44 32 75 10z m-364 0 c12 -5 16 -21 16 -65 l0 -59 -44 0 c-72 0 -93 56 -28 75
38 11 42 25 8 25 -13 0 -26 7 -30 15 -4 12 2 15 28 15 19 0 41 -3 50 -6z m81
-59 c0 -49 -3 -60 -17 -63 -16 -3 -18 5 -18 63 0 58 2 66 18 63 14 -3 17 -14
17 -63z m95 51 c0 -8 -6 -16 -14 -19 -9 -4 -16 -23 -18 -49 -2 -31 -8 -44 -20
-46 -15 -3 -18 5 -18 52 0 42 4 57 18 65 25 15 52 13 52 -3z"/>
<path d="M2786 1863 c-11 -11 -6 -23 9 -23 8 0 15 4 15 9 0 13 -16 22 -24 14z"/>
<path d="M2417 1813 c-12 -11 -8 -23 8 -23 8 0 15 7 15 15 0 16 -12 20 -23 8z"/>
<path d="M3850 2246 c12 -16 12 -19 -5 -29 -27 -15 -39 -18 -135 -31 -30 -5
-60 -12 -67 -18 -12 -9 -13 -8 -39 40 -14 25 -15 13 -12 -141 l3 -168 -25 3
c-25 3 -25 4 -27 113 -4 156 -1 150 -74 153 -34 1 -92 13 -130 26 -78 27 -78
27 -120 -54 -21 -39 -24 -59 -24 -155 0 -101 2 -114 28 -164 47 -89 124 -152
242 -196 l20 -8 -20 -5 c-11 -2 -24 -8 -30 -13 -5 -5 57 -9 155 -9 98 0 160 4
155 9 -6 5 -19 11 -30 13 -15 2 -5 11 36 31 84 41 143 98 181 174 43 89 51
209 19 295 -22 57 -70 126 -99 142 -15 9 -15 8 -2 -8z m30 -36 c0 -5 -4 -10
-10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-432 -81 l49
-10 2 -116 c2 -128 -8 -174 -44 -197 -36 -24 -112 -21 -125 4 -10 18 -8 20 30
20 30 0 47 7 65 25 33 32 34 59 3 48 -96 -33 -165 40 -136 144 13 48 33 71 72
82 17 5 32 10 33 10 1 1 24 -4 51 -10z m351 -3 c46 -24 64 -61 59 -122 -5 -62
-25 -90 -77 -104 -86 -24 -151 29 -151 124 0 43 4 53 36 82 40 38 85 45 133
20z"/>
<path d="M3386 2079 c-36 -10 -46 -24 -46 -67 0 -49 16 -72 50 -72 43 0 60 23
60 85 0 59 -11 68 -64 54z"/>
<path d="M3705 2065 c-30 -30 -32 -64 -4 -99 46 -59 118 -11 103 69 -10 58
-58 72 -99 30z"/>
<path d="M1443 2139 c-229 -38 -293 -165 -121 -239 115 -49 364 -66 529 -34
300 57 291 224 -16 274 -72 12 -319 11 -392 -1z m27 -91 l0 -53 25 53 c21 46
28 52 54 52 38 0 42 -7 30 -61 -24 -109 -29 -119 -53 -119 -20 0 -23 4 -19 28
l4 27 -18 -27 c-11 -17 -27 -28 -40 -28 -19 0 -23 6 -24 33 l-1 32 -9 -32 c-7
-25 -15 -33 -33 -33 l-23 0 17 79 c21 97 24 101 61 101 28 0 29 -1 29 -52z
m346 44 c6 -4 17 -25 24 -47 l14 -40 11 45 c9 36 15 45 33 45 28 0 28 -3 6
-97 -16 -74 -19 -78 -45 -78 -24 0 -30 6 -41 42 l-13 42 -11 -39 c-9 -33 -16
-41 -39 -43 -20 -3 -26 0 -23 10 3 7 13 48 23 91 17 77 29 91 61 69z m-56 -9
c-1 -18 -16 -31 -40 -34 -22 -4 -27 -12 -38 -66 -12 -56 -16 -63 -38 -63 -28
0 -28 -1 -9 70 8 30 15 56 15 58 0 1 -11 2 -25 2 -18 0 -25 5 -25 20 0 18 7
20 80 20 44 0 80 -3 80 -7z"/>
<path d="M4015 2040 c8 -54 -15 -173 -46 -237 -11 -24 -36 -62 -55 -84 -46
-55 -43 -62 7 -14 81 79 128 215 109 317 -13 65 -24 79 -15 18z"/>
<path d="M1135 1916 c21 -129 113 -214 285 -264 123 -36 176 -44 251 -39 198
14 356 80 428 179 42 57 39 70 -6 26 -151 -144 -496 -183 -726 -81 -109 48
-169 100 -226 198 -10 17 -11 14 -6 -19z"/>
<path d="M0 40 l0 -40 3310 0 3310 0 0 40 0 40 -3310 0 -3310 0 0 -40z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
